<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Payout Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source">
          <option *ngFor="let source of sourceList | keyvalue" [ngValue]="source.value">{{source.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Year</u></label>
        <select [(ngModel)]="filterable.year" class="form-control" placeholder="Year">
          <option *ngFor="let year of yearList" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Month</u></label>
        <select [(ngModel)]="filterable.month" class="form-control" placeholder="Month">
          <option *ngFor="let month of monthList" [ngValue]="month.value">{{month.name}}</option>
        </select>
      </div>
      <div class="col-2 ml-auto text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">坏账报表</button>
        <button class="btn btn-primary btn-sm mr-2" (click)="verifyExport()">付款核对</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="emptyResult">
  <div class="loader" *ngIf="loading">Loading...</div>
  <div class="alert alert-warning mt-3 w-100" *ngIf="!loading">Empty Result...</div>
</div>

<div *ngIf="!emptyResult">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mt-4">
    <li *ngFor="let tabData of tabDatas; index as i;" [ngbNavItem]="i">
      <a ngbNavLink>
        <h5>{{tabData.title}}</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="table table-striped table-bordered mt-3 text-center" style="width:100%">
            <thead>
              <tr>
                <th>No.</th>
                <th>Title</th>
                <th>URL</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let urlMap of tabData.urls | keyvalue; index as i">
                <td>{{i + 1}}</td>
                <td>{{urlMap.key}}</td>
                <td class="text-left">
                  <a href={{urlMap.value}} target="_blank">{{urlMap.value}}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2 mb-4"></div>
</div>
